var exports = {
  "kL": "xdbfd91f1--fd35b2--container",
  "N4": "xdbfd91f1--fd35b2--feature",
  "Qq": "xdbfd91f1--fd35b2--text",
  "j_": "xdbfd91f1--fd35b2--feature-img",
};

module.exports = exports;
